import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const isDark = () => document.documentElement.classList.contains("dark");

export default function ThemeToggle() {
  const [dark, setDark] = useState(isDark);

  // Follow the device setting until the user makes a manual choice.
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => {
      if (!localStorage.getItem("theme")) {
        document.documentElement.classList.toggle("dark", e.matches);
        setDark(e.matches);
      }
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const toggle = () => {
    const next = !dark;
    localStorage.setItem("theme", next ? "dark" : "light");
    document.documentElement.classList.toggle("dark", next);
    setDark(next);
  };

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      className="h-8 w-8 flex items-center justify-center rounded-sm text-zinc-500 hover:bg-zinc-200 hover:text-zinc-900 transition-colors"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
